import React from 'react';
import { XpressId } from '../../shared/XpressId/XpressId';
import { CompletedMessage } from './CompletedMessage/CompletedMessage';
import { ErrorMessage } from 'components/VideoSelfieRecovery/VideoSelfie/ErrorMessage/ErrorMessage';
import { useVideoSelfieCapture } from 'components/VideoSelfieRecovery/VideoSelfie/hooks/useVideoSelfieCapture';

export const VideoSelfie = ({ clientId, token }) => {
    const {
        accessToken,
        documentType,
        showCompletedMessage,
        videoSelfieError,
        handleProcessCompleted,
        handleProcessError,
        handleProcessEvents,
    } = useVideoSelfieCapture({ clientId, token });

    if (showCompletedMessage) return <CompletedMessage />;
    if (videoSelfieError) return <ErrorMessage statusCode={videoSelfieError.statusCode} documentType={documentType} />;

    return (
        <XpressId
            accessToken={accessToken}
            onProcessCompleted={handleProcessCompleted}
            onProcessError={handleProcessError}
            onProcessEvents={handleProcessEvents}
            clientId={clientId}
            token={token}
        />
    );
};
